<script lang="ts">
  import { useLocation } from "svelte-navigator";
  import Link from "../Link.svelte";
  import type { BreadcrumbItems } from "./types";

  const location = useLocation();

  const BREADCRUMB_LABEL_MAP = {
    "/anklet": "Anklet",
    "/band": "Band",
    "/birthstone-ring": "Birthstone Ring",
    "/birthstone-studs": "Birthstone Studs",
    "/charm-studs": "Charm Studs",
    "/bracelet": "Bracelet",
    "/diamond-studs": "Diamond Studs",
    "/diamond-earrings": "Diamond Earrings",
    "/duet": "Duet",
    "/necklace": "Necklace",
    "/solitaire": "Solitaire",
    "/toi-et-moi": "Toi Et Moi",
    "/trilogy": "Trilogy",
    "/trio": "Trio",
  };

  let breadcrumbs: BreadcrumbItems = [];
  $: {
    breadcrumbs = [
      {
        label: "Builder",
        link: "/",
      },
    ];

    const mapped = BREADCRUMB_LABEL_MAP[$location.pathname];
    if (mapped) {
      breadcrumbs.push({
        label: mapped,
        link: `${$location.pathname}${$location.search}`,
      });
    }
  }
</script>

<nav>
  <ol>
    {#each breadcrumbs as breadcrumb, index}
      <li>
        {#if index}<span class="break">/</span>{/if}
        <Link href={breadcrumb.link}>
          {breadcrumb.label}
        </Link>
      </li>
    {/each}
  </ol>
</nav>

<style>
  nav {
    display: flex;
    font-family: "Cormorant Garamond";
    letter-spacing: 2px;
    text-transform: uppercase;
    font-size: 0.7rem;
  }

  ol {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .break {
    padding-inline: 6px 2px;
  }
</style>
